import { IS_LOADING, SUCCESS, HAS_ERROR } from "./actions";

export const initialState = {
  isLoading: false,
  hasError: false,
  data: {
    byHour: [],
    byDay: {},
    byWeek: {},
    byMonth: {},
  },
  error: null,
};

const pickBorrowingReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        error: null,
      };

    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload || initialState.data,
        hasError: false,
        error: null,
      };

    case HAS_ERROR:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default pickBorrowingReducer;
